import { createSlice } from '@reduxjs/toolkit';

// ================ Slice ================ //

/**
 * Holds the clean `/sewa-...` paths that the daily SEO eligibility job
 * currently marks as live, and the current SEO category taxonomy (L2/L3
 * auto-detected from Sharetribe + CAT4, see
 * server/api-util/seoTaxonomyMerge.js). Both are put into the store on the
 * server (server/dataLoader.js dispatches these action types directly as
 * plain data — it's plain CommonJS and can't import this ESM module, same
 * reason eligiblePaths already worked this way) and reach the client
 * through the SSR preloaded state, so no extra API call or `useEffect` is
 * needed. `seoCategories` defaults to `null` (not `[]`) so callers can tell
 * "not loaded yet, use the bundled default" apart from "loaded and empty".
 */
const seoPagesSlice = createSlice({
  name: 'seoPages',
  initialState: {
    eligiblePaths: [],
    seoCategories: null,
  },
  reducers: {
    setEligiblePaths: (state, action) => {
      state.eligiblePaths = action.payload || [];
    },
    setSeoCategories: (state, action) => {
      state.seoCategories = action.payload || null;
    },
  },
});

export const { setEligiblePaths, setSeoCategories } = seoPagesSlice.actions;

export default seoPagesSlice.reducer;
